import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ChoosePCPAlert } from '../../../../common/Alert/ChoosePCPAlert';
import { Constants } from '../../../../common/Constants';
import { EAPCode } from '../../../../common/EAPCode';
import { CompareProvider } from '../../../../models/Provider';
import { DownloadResultsButton } from '../ViewAll/DownloadResultsButton';
import { ShareCompareButton } from '../ViewAll/ShareCompareButton';
import { ExpandedSearchRadiusBanner } from './ExpandedSearchRadiusBanner';
import { FiltersContainerDesktop } from './FiltersContainerDesktop';
import { EAPStyle } from './MapView.styled';
import { FilterProviderResultsPrintViewProps } from './Print/FilterProviderResultsPrintView';

type Props = {
  pageHeader: string;
  sectionType: string;
  mobileScreen: boolean;
  eapCodeFlag;
  isBHCare;
  isPageTracked: boolean;
  openCompare?: boolean;
  setOpenCompare: (a: boolean) => void;
  setOpenShare: (a: boolean) => void;
  setCompareShareToggle?: (a: boolean) => void;
  setSelectedCheckbox: (a: { checked: {} }) => void;
  setSelectedItems: (a: CompareProvider[]) => void;
  setOpenBoxContents: (a: boolean) => void;
  openShare: boolean;
  resultSet: any;
  enableMapViewEnhancements: boolean;
  previousLocation: string;
  setPreviousLocation: (a: string) => void;
  filterProviderResultsPrintViewProps?: FilterProviderResultsPrintViewProps;
};

export const MapViewHeader = ({
  pageHeader,
  sectionType,
  mobileScreen,
  eapCodeFlag,
  isBHCare,
  isPageTracked,
  openCompare,
  setOpenCompare,
  setOpenShare,
  setCompareShareToggle,
  setSelectedCheckbox,
  setSelectedItems,
  setOpenBoxContents,
  openShare,
  resultSet,
  enableMapViewEnhancements,
  previousLocation,
  setPreviousLocation,
  filterProviderResultsPrintViewProps,
}: Props) => {
  const { t } = useTranslation();
  const [isClicked, setIsClicked] = useState<boolean>(false);

  return (
    <React.Fragment>
      {!enableMapViewEnhancements && <ExpandedSearchRadiusBanner />}
      <Layout.Stack
        alignItems="left"
        css={{ '@media (max-width: 464px)': { display: 'none' } }}
        grow={true}
        space={0}
      >
        {!enableMapViewEnhancements && (
          <Layout.Group
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <Heading
              css={{
                'abyss-heading-root': {
                  '@media (max-width: 744px)': {
                    fontSize: 'medium !important',
                    lineHeight: '$lg !important',
                  },
                  marginBottom: '$sm',
                },
              }}
              data-auto-testid="results-heading"
              data-testid="results-heading"
              level={2}
              size="sm"
              textAlign="left"
            >
              {pageHeader}
            </Heading>
            <Flex>
              <Layout.Group space={15}>
                <Layout.Group space={15}>
                  <React.Fragment>
                    {sectionType === Constants.RESULT_SECTION.PROVIDER && (
                      <ShareCompareButton
                        isShareButton={false}
                        openCompare={openCompare}
                        sectionType={sectionType}
                        setIsClicked={setIsClicked}
                        setOpenCompare={setOpenCompare}
                        setOpenShare={setOpenShare}
                        setSelectedCheckbox={setSelectedCheckbox}
                        setSelectedItems={setSelectedItems}
                        text={t('COMPARE_BUTTONS.COMPARE')}
                        view="desktop"
                      />
                    )}
                    <ShareCompareButton
                      openShare={openShare}
                      sectionType={sectionType}
                      setIsClicked={setIsClicked}
                      setOpenCompare={setOpenCompare}
                      setOpenShare={setOpenShare}
                      setSelectedCheckbox={setSelectedCheckbox}
                      setSelectedItems={setSelectedItems}
                      text={t('COMPARE_BUTTONS.SHARE')}
                      view="desktop"
                    />
                  </React.Fragment>
                  {!enableMapViewEnhancements && (
                    <DownloadResultsButton
                      enableMapViewEnhancements={false}
                      filterProviderResultsPrintViewProps={
                        filterProviderResultsPrintViewProps
                      }
                      isClicked={isClicked}
                      results={resultSet}
                      setCompareShareToggle={setCompareShareToggle}
                      setIsClicked={setIsClicked}
                      setOpenBoxContents={setOpenBoxContents}
                      setOpenCompare={setOpenCompare}
                      setOpenShare={setOpenShare}
                      setSelectedCheckbox={setSelectedCheckbox}
                      setSelectedItems={setSelectedItems}
                      text={t('COMPARE_BUTTONS.DOWNLOAD_RESULTS')}
                      view="desktop"
                    />
                  )}
                </Layout.Group>
              </Layout.Group>
            </Flex>
          </Layout.Group>
        )}

        {!enableMapViewEnhancements && (
          <React.Fragment>
            <ChoosePCPAlert isMapView />
            <FiltersContainerDesktop
              previousLocation={previousLocation}
              resultSet={resultSet}
              sectionType={sectionType}
              setPreviousLocation={setPreviousLocation}
            />
          </React.Fragment>
        )}
      </Layout.Stack>

      {!enableMapViewEnhancements &&
        !mobileScreen &&
        isPageTracked &&
        eapCodeFlag &&
        isBHCare && (
          <EAPStyle>
            <EAPCode />
          </EAPStyle>
        )}
    </React.Fragment>
  );
};
